import Code from '@/components/dashboard/Code';
import ClientCode from '@/components/dashboard/ClientCode';
import SectionActions from '@/docs/SectionActions';
import Links from '@/docs/ExampleLinks';
import { useRef } from 'react'
import SEOMetadata from '@/components/SEOMetadata';
import DocHeading from '@/docs/DocHeading';

export default function NewsAPIDoc() {
  const sectionRef = useRef(null);
  return (
    <div className="api-documentation space-y-8 lg:max-w-[calc(100vw-340px)] md:max-w-[calc(100vw-80px)] max-w-[calc(100vw-30px)] overflow-hidden md:overflow-visible pb-50">
      <SEOMetadata title="Live Feed - News API" description="Query live feed data via the News API; request parameters, code examples and the response schema for the live feed endpoint."  canonicalUrl="https://axionquant.com/docs/04-macros-and-signals/news/live-feed" />
      <DocHeading className="text-3xl font-bold text-gray-900 mb-4">Live Feed - News API</DocHeading>

      <div className="space-y-12" ref={sectionRef}>
        {/* Get General News */}
        <div className="flex flex-col lg:flex-row lg:gap-8 max-w-[1600px]">
          <div className="flex-1 min-w-0 lg:pr-6 xl:pr-12">
            <div className="mb-6">
              <div className="flex flex-wrap items-center gap-4 mb-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  GET
                </span>
                <code className="text-lg font-mono text-gray-800 bg-gray-50 px-3 py-1 rounded break-all">
                  /news
                </code>
              </div>
              <p className="text-gray-700 mb-6">
                Retrieves a broad selection of current news articles across all categories and regions. This endpoint provides a general news feed ideal for staying informed about global events and trending topics.
              </p>
            </div>
            <Links links={['/news', '/news?limit=50']} />
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-900 mb-3">Response Fields</h3>
              <p className="text-sm text-gray-600 mb-3">Same structure as Company News response.</p>
              <div className="space-y-3">
                <div className="border-l-4 border-blue-500 pl-4">
                  <p className="font-mono text-sm text-gray-800 mb-1">title <span className="text-gray-500">string</span></p>
                  <p className="text-sm text-gray-600">Article headline</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4">
                  <p className="font-mono text-sm text-gray-800 mb-1">link <span className="text-gray-500">string</span></p>
                  <p className="text-sm text-gray-600">Encoded URL to the full article</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4">
                  <p className="font-mono text-sm text-gray-800 mb-1">summary <span className="text-gray-500">string</span></p>
                  <p className="text-sm text-gray-600">Article summary or excerpt</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4">
                  <p className="font-mono text-sm text-gray-800 mb-1">published <span className="text-gray-500">string</span></p>
                  <p className="text-sm text-gray-600">Publication date (RFC 1123 format)</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 min-w-0">
            <div className="rounded-lg p-0 !pt-0 pb-4 lg:sticky lg:top-[12px]">
              <SectionActions sectionTitle="General News" contentRef={sectionRef} />
              <h3 className="text-sm font-semibold mb-3">General News</h3>
              <div className="mb-4">
                <p className="text-gray-400 text-xs mb-2">Request</p>
                <ClientCode id="news/general"></ClientCode>
              </div>
              <div>
                <p className="text-gray-400 text-xs mb-2">Response</p>
                <Code id="04-macros-and-signals/news/live-feed"></Code>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
